import React from 'react';

interface IHintIconInfoProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const HintIconInfo = ({
	size = '24',
	className = '',
	fill = '#0079C0',
}: IHintIconInfoProps) => (
	<svg
		role="img"
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-labelledby="hintIconInfo">
		<path
			d="M12 2C14.6522 2 17.1959 3.05335 19.0713 4.92871C20.9467 6.80407 22 9.34784 22 12C22 14.6522 20.9467 17.1959 19.0713 19.0713C17.1959 20.9467 14.6522 22 12 22C9.34784 22 6.80407 20.9467 4.92871 19.0713C3.05335 17.1959 2 14.6522 2 12C2 6.64975 6.20167 2.28054 11.4854 2.0127L12 2ZM11 17H13V11H11V17ZM11 9H13V7H11V9Z"
			fill={fill}
		/>
	</svg>
);
